import React, { useState } from "react";
import { observer } from "mobx-react-lite";
import { globalVars } from "../../global/GlobalVars.js";
import * as language from "../../utils/language.js";
import * as rwData from "../../utils/rwData.js";

const Button = observer((props) => {
  //========================================================================
  // Wert aus globalVars auslesen
  let value = rwData.readRcvValue(props.props.variable);

  //========================================================================
  // Auswerten, ob Aktiv
  let isActive;
  if (value.value === props.element.valueToWrite) {
    isActive = true;
  } else {
    isActive = false;
  }

  //========================================================================
  // State für den "gedrückt" Zustand
  const [isPressed, setIsPressed] = useState(false);

  //========================================================================
  // neuen Wert schreiben
  const handleInputChange = () => {
    let verifiedValue = props.element.valueToWrite;
    // Wert in globalVars schreiben
    if (props.authWrite) {
      if (isFinite(verifiedValue)) {
        rwData.writeValue(
          props.props.variable.toString(),
          verifiedValue,
          value.value
        );
      }
    }
  };

  //========================================================================
  // Maus-Event-Handler
  const handleMouseDown = () => {
    setIsPressed(true);
  };

  const handleMouseUp = () => {
    setIsPressed(false);
    handleInputChange();
  };

  const handleMouseLeave = () => {
    setIsPressed(false);
  };

  const handleTouchStart = () => {
    setIsPressed(true);
  };

  const handleTouchEnd = () => {
    setIsPressed(false);
    handleInputChange();
  };

  //========================================================================
  // Grafische Darstellung
  return (
    <button
      style={{
        ...props.style,
        visibility: props.props.visibility,
        backgroundColor: isActive
          ? props.element.activeColor
          : props.style.backgroundColor || "#333",
        transform: isPressed ? "scale(0.95)" : "scale(1)",
        cursor: "pointer",
        transition: "transform 0.1s, box-shadow 0.1s",
        boxShadow: isPressed
          ? "inset 2px 2px 5px rgba(0,0,0,0.5)"
          : "2px 2px 5px rgba(0,0,0,0.3)",
        // border: "none",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        // Text mehrzeilig mit \n
        whiteSpace: "pre-wrap",
        textAlign: "center",
      }}
      onMouseDown={handleMouseDown}
      onMouseUp={handleMouseUp}
      onMouseLeave={handleMouseLeave}
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}
      title={
        language.displayText(value.name) +
        (globalVars.cyclicUpdate || globalVars.editor
          ? "\n" +
            ("Variable: " +
              props.props.variable +
              ", Wert: " +
              props.element.valueToWrite)
          : "")
      }
    >
      <div
        style={{
          overflow: "hidden",
          boxSizing: "border-box",
        }}
      >
        {language.displayText(props.props.text)}
      </div>
    </button>
  );
});

export default Button;
